angular
    .module('app.controllers')
    .controller('InvestmentsController', function ($scope, $rootScope, $translate, notify, investmentsListFilterFactory, api, formValidator, UserService) {
        $scope.filter = investmentsListFilterFactory;
        $scope.clientOptions = [];
        $scope.statusOptions = [
            { value: 'investment_active', label: $translate.instant('group_active') },
            { value: 'investment_inactive', label: $translate.instant('group_inactive') },
        ];

        const InvestmentModel = api('investments');

        $scope.investments = [];
        $scope.loadList = () => {
            const info = notify.info($translate.instant('loading'));
            InvestmentModel.list().then((response) => {
                $scope.investments = response.data;
                info.close();
                notify.success($translate.instant('loaded'));
            });
        };
        $scope.loadList();

        $scope.editInvestment = (id) => {
            const model = _.find($scope.investments, { id }) || {
                status: 'investment_active',
            };
            $scope.currentInvestment = angular.extend({}, model);
            if (model.client) {
                $scope.clientsOptions = [{ id: model.client.id, name: model.client.name }];
            } else {
                $scope.clientsOptions = [];
            }
        };

        // form validation
        const fv = formValidator('#InvestmentForm', $scope);

        $scope.saveInvestment = () => {
            if (!fv.isValid()) {
                return;
            }

            const info = notify.info($translate.instant('saving'));
            notify.global(1);

            InvestmentModel.save($scope.currentInvestment.id || 0, $scope.currentInvestment).then((response) => {
                // zamiana/dodanie
                const index = _.findIndex($scope.investments, { id: $scope.currentInvestment.id || 0 });

                if (-1 !== index) {
                    $scope.investments[index] = response;
                } else {
                    $scope.investments.push(response);
                }

                InvestmentModel.clearCache();

                info.close();
                notify.success($translate.instant('saved'));
                notify.global(0);
            });
        };
    });
